import React, { useState } from "react";
import ResiduoForm from "./componentes/registrosForm";
import CombustibleForm from "./componentes/combustibleForm";
import "./App.css";

const App = () => {
  const [activeTab, setActiveTab] = useState("residuo");

  return (
    <>
      <h3 style={{ textAlign: "center", margin: "20px" }}>
        Registro de Combustibles y Residuos
      </h3>
      <div className="contenedor-principal">
        <div className="tabs">
          <button
            className={activeTab === "residuo" ? "tab active" : "tab"}
            onClick={() => setActiveTab("residuo")}
          >
            Registro de Residuos
          </button>
          <button
            className={activeTab === "combustible" ? "tab active" : "tab"}
            onClick={() => setActiveTab("combustible")}
          >
            Registro de Combustibles
          </button>
        </div>

        <div className="formulario-wrapper">
          {activeTab === "residuo" && <ResiduoForm />}
          {activeTab === "combustible" && <CombustibleForm />}
        </div>
      </div>
    </>
  );
};

export default App;
